import createDesignSystemTheme from './createDesignSystemTheme';
import defaultThemeValues from './defaultThemeValues';
export default createDesignSystemTheme(defaultThemeValues);
